import { render, staticRenderFns } from "./CourseClass.vue?vue&type=template&id=665aa925&scoped=true"
import script from "./CourseClass.vue?vue&type=script&lang=js"
export * from "./CourseClass.vue?vue&type=script&lang=js"
import style0 from "./CourseClass.vue?vue&type=style&index=0&id=665aa925&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665aa925",
  null
  
)

export default component.exports